import { useAuthStore } from 'stores/authStore';
import { useCurrentUser } from './useCurrentUser';

export const useCurrentRole = () => {
  const roleId = useAuthStore((state) => state.currentRoleId);
  const currentRoles = useCurrentUser()?.roles;

  // The current role is whatever the acting role points to — including a Faks org role.
  return currentRoles?.find((role) => role.id === roleId) ?? null;
};
